import advisor from "@app/assets/images/onboarding/visitor-advisor.svg";
import business from "@app/assets/images/onboarding/visitor-business.svg";

import { ChoiceCard, FunnelScreen } from "../screen";

import type { ScreenProps } from "../types";

// By option id, so the cards keep their pictures if funnel.ts reorders them.
const ART: Record<string, string> = {
  BUSINESS: business,
  ADVISOR: advisor,
};

// The funnel's first screen: two illustrated cards, and a way out for anyone
// neither of them fits. Picking a card IS the answer — there is no Continue,
// because there is nothing to confirm.
//
// "Neither" saves no option at all, which is what makes it a skip rather than a
// third card, and what sends the walk to the role question. See funnel.ts.
export default function VisitorTypeStep({
  step,
  busy,
  save,
  skip,
  back,
}: ScreenProps) {
  return (
    <FunnelScreen back={back} title={step.title}>
      <div className="mt-6 grid grid-cols-2 gap-3">
        {(step.options ?? []).map((option) => (
          <ChoiceCard
            key={option.id}
            label={option.name}
            illustration={ART[option.id]}
            onClick={() => !busy && save({ values: [option.id] })}
          />
        ))}
      </div>

      {skip && (
        <p className="mt-5 text-center">
          <button
            type="button"
            onClick={() => !busy && skip()}
            className="text-body text-zinc-500 underline decoration-zinc-300 underline-offset-4 transition-colors hover:text-zinc-700 hover:decoration-zinc-500"
          >
            Neither
          </button>
        </p>
      )}
    </FunnelScreen>
  );
}
